import * as Sentry from '@sentry/vue'
import { useSPAErrorHandling } from '~/composables/monitoring/useSPAErrorHandling'
import { useMonitoring } from '~/composables/monitoring/useMonitoring'

export default defineNuxtPlugin(() => {
  const { monitorMemoryLeaks } = useSPAErrorHandling()
  const { monitorNetworkStatus } = useMonitoring()
  monitorMemoryLeaks()
  monitorNetworkStatus()

  let lastLongTaskBreadcrumb = 0
  let longTaskObserver: PerformanceObserver | undefined

  if ('PerformanceObserver' in window && PerformanceObserver.supportedEntryTypes?.includes('longtask')) {
    longTaskObserver = new PerformanceObserver((list) => {
      const now = performance.now()
      const sinceLast = now - lastLongTaskBreadcrumb
      for (const entry of list.getEntries() as PerformanceEntry[]) {
        if (entry.duration >= 180 && sinceLast >= 30_000) {
          console.log('Long task detected:', entry)
          lastLongTaskBreadcrumb = now
          Sentry.addBreadcrumb({
            category: 'performance',
            message: 'Long task detected',
            level: 'warning',
            data: {
              duration: Math.round(entry.duration),
              startTime: Math.round(entry.startTime),
              name: entry.name || 'longtask'
            }
          })
          break // one breadcrumb per batch
        }
      }
    })
    longTaskObserver.observe({ entryTypes: ['longtask'] })
  }

  const router = useRouter()
  router.onError((error) => {
    const msg = String(error?.message || '')
    if (
      msg.includes('Navigation aborted') ||
      msg.includes('Avoided redundant navigation') ||
      (msg.includes('Loading chunk') && !msg.includes('failed'))
    ) {
      return
    }

    Sentry.captureException(error, {
      tags: {
        'error.type': 'routing',
        'route.from': router.currentRoute.value.path
      }
    })
  })
})
